import React, { useState, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom';
import HomeNavigate from './website/HomeNavigate'
import PageNotFound from './website/components/PageHandler/PageNotFound';
import PageNotFoundDay from './website/components/PageHandler/PageNotFoundDay';
import LoginPage from './erp/pages/login/loginPage';
import Dashboard from './erp/components/dashboard/Dashboard';
import NetworkError from './website/components/PageHandler/NetworkError';
import BadResponse from './erp/pages/responsepages/BadResponse';
import AboutClick from './website/pages/About/AboutClick';

function RoutingComponent() {
  const [pnp, setPnp] = useState(() => {
    const time = new Date();
    return time.getHours() >= 6 && time.getHours() <= 18;
  });

  return (
    <Routes>
      <Route path='/' element={<HomeNavigate />} />
      <Route path='/login' element={<LoginPage />} />
      <Route path='/dashboard' element={<Dashboard />} />
      <Route path='/about-us' element={<AboutClick />} />
      <Route path='/net-error' element={<NetworkError />} />
      <Route path='/server-error' element={<BadResponse />} />
      <Route path='*' element={pnp ? <PageNotFoundDay /> : <PageNotFound />} />
    </Routes>
  )
}

export default RoutingComponent
